import { render, staticRenderFns } from "./featureComponent.vue?vue&type=template&id=0b54a31e&scoped=true&"
import script from "./featureComponent.vue?vue&type=script&lang=js&"
export * from "./featureComponent.vue?vue&type=script&lang=js&"
import style0 from "./featureComponent.vue?vue&type=style&index=0&id=0b54a31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54a31e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b54a31e')) {
      api.createRecord('0b54a31e', component.options)
    } else {
      api.reload('0b54a31e', component.options)
    }
    module.hot.accept("./featureComponent.vue?vue&type=template&id=0b54a31e&scoped=true&", function () {
      api.rerender('0b54a31e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/featureComponent.vue"
export default component.exports